import { render, staticRenderFns } from "./FunctionItem.vue?vue&type=template&id=2182f238&scoped=true&"
import script from "./FunctionItem.vue?vue&type=script&lang=js&"
export * from "./FunctionItem.vue?vue&type=script&lang=js&"
import style0 from "./FunctionItem.vue?vue&type=style&index=0&id=2182f238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182f238",
  null
  
)

export default component.exports